export enum IEventListActionTypes {
  FETCH_EVENT_LIST_REQUEST = "FETCH_EVENT_LIST_REQUEST",
  FETCH_EVENT_LIST_SUCCESS = "FETCH_EVENT_LIST_SUCCESS",
  FETCH_EVENT_LIST_FAILURE = "FETCH_EVENT_LIST_FAILURE",
}

export type IEventType = {
  event_id?: number;
  event_name?: string;
  event_venue_name?: string;
  event_type_name?: string;
  start_date?: string;
  end_date?: string;
  host_name?: string;
  event_banner_storage_prefix?: string;
  event_status?: string;
};

export type IEventListState = {
  data: IEventType[];
};

export type IEventListActionCreator = {
  type: string;
  payload: IEventType;
};

export enum IEventIndividualActionTypes {
  FETCH_EVENT_INDIVIDUAL_REQUEST = "FETCH_EVENT_INDIVIDUAL_REQUEST",
  FETCH_EVENT_INDIVIDUAL_SUCCESS = "FETCH_EVENT_INDIVIDUAL_SUCCESS",
  FETCH_EVENT_INDIVIDUAL_FAILURE = "FETCH_EVENT_INDIVIDUAL_FAILURE",
}

export type IEventIndividualType = {
  id?: number;
  event_name?: string;
  start_date?: string;
  end_date?: string;
  link?: string;
  host_name?: string;
  organizer_id?: string;
  event_type?: {
    id?: number;
    name?: string;
  };
  event_venue?: {
    id?: number;
    name?: string;
  };
  description?: string;
  status?: string;
  event_banner_storage_prefix?: string;
  event_schedules?: any[];
};

export type IEventIndividualState = {
  data: IEventIndividualType;
};

export type IEventActionCreator = {
  type: string;
  payload: IEventIndividualType;
};

export enum IEventGroupActionTypes {
  FETCH_EVENT_GROUPS_REQUEST = "FETCH_EVENT_GROUPS_REQUEST",
  FETCH_EVENT_GROUPS_SUCCESS = "FETCH_EVENT_GROUPS_SUCCESS",
  FETCH_EVENT_GROUPS_FAILURE = "FETCH_EVENT_GROUPS_FAILURE",

  FETCH_EVENT_TYPES_REQUEST = "FETCH_EVENT_TYPES_REQUEST",
  FETCH_EVENT_TYPES_SUCCESS = "FETCH_EVENT_TYPES_SUCCESS",
  FETCH_EVENT_TYPES_FAILURE = "FETCH_EVENT_TYPES_FAILURE",

  FETCH_EVENT_VENUES_REQUEST = "FETCH_EVENT_VENUES_REQUEST",
  FETCH_EVENT_VENUES_SUCCESS = "FETCH_EVENT_VENUES_SUCCESS",
  FETCH_EVENT_VENUES_FAILURE = "FETCH_EVENT_VENUES_FAILURE",

  FETCH_EMPLOYEES_WITH_PROJECTS_REQUEST = "FETCH_EMPLOYEES_WITH_PROJECTS_REQUEST",
  FETCH_EMPLOYEES_WITH_PROJECTS_SUCCESS = "FETCH_EMPLOYEES_WITH_PROJECTS_SUCCESS",
  FETCH_EMPLOYEES_WITH_PROJECTS_FAILURE = "FETCH_EMPLOYEES_WITH_PROJECTS_FAILURE",

  FETCH_HOLIDAYS_REQUEST = "FETCH_HOLIDAYS_REQUEST",
  FETCH_HOLIDAYS_SUCCESS = "FETCH_HOLIDAYS_SUCCESS",
  FETCH_HOLIDAYS_FAILURE = "FETCH_HOLIDAYS_FAILURE",

  FETCH_SHIFTS_REQUEST = "FETCH_SHIFTS_REQUEST",
  FETCH_SHIFTS_SUCCESS = "FETCH_SHIFTS_SUCCESS",
  FETCH_SHIFTS_FAILURE = "FETCH_SHIFTS_FAILURE",

  FETCH_GROUP_MEMBERS_REQUEST = "FETCH_GROUP_MEMBERS_REQUEST",
  FETCH_GROUP_MEMBERS_SUCCESS = "FETCH_GROUP_MEMBERS_SUCCESS",
  FETCH_GROUP_MEMBERS_FAILURE = "FETCH_GROUP_MEMBERS_FAILURE",

  FETCH_MASTER_PROJECTS_REQUEST = "FETCH_MASTER_PROJECTS_REQUEST",
  FETCH_MASTER_PROJECTS_SUCCESS = "FETCH_MASTER_PROJECTS_SUCCESS",
  FETCH_MASTER_PROJECTS_FAILURE = "FETCH_MASTER_PROJECTS_FAILURE",

  FETCH_MASTER_TEAMS_REQUEST = "FETCH_MASTER_TEAMS_REQUEST",
  FETCH_MASTER_TEAMS_SUCCESS = "FETCH_MASTER_TEAMS_SUCCESS",
  FETCH_MASTER_TEAMS_FAILURE = "FETCH_MASTER_TEAMS_FAILURE",

  FETCH_MASTER_SUB_PROJECTS_REQUEST = "FETCH_MASTER_SUB_PROJECTS_REQUEST",
  FETCH_MASTER_SUB_PROJECTS_SUCCESS = "FETCH_MASTER_SUB_PROJECTS_SUCCESS",
  FETCH_MASTER_SUB_PROJECTS_FAILURE = "FETCH_MASTER_SUB_PROJECTS_FAILURE",

  FETCH_MASTER_PROJECT_DETAILS_REQUEST = "FETCH_MASTER_PROJECT_DETAILS_REQUEST",
  FETCH_MASTER_PROJECT_DETAILS_SUCCESS = "FETCH_MASTER_PROJECT_DETAILS_SUCCESS",
  FETCH_MASTER_PROJECT_DETAILS_FAILURE = "FETCH_MASTER_PROJECT_DETAILS_FAILURE",

  FETCH_MASTER_SUB_PROJECT_DETAILS_REQUEST = "FETCH_MASTER_SUB_PROJECT_DETAILS_REQUEST",
  FETCH_MASTER_SUB_PROJECT_DETAILS_SUCCESS = "FETCH_MASTER_SUB_PROJECT_DETAILS_SUCCESS",
  FETCH_MASTER_SUB_PROJECT_DETAILS_FAILURE = "FETCH_MASTER_SUB_PROJECT_DETAILS_FAILURE",

  FETCH_MASTER_SUB_TEAMS_REQUEST = "FETCH_MASTER_SUB_TEAMS_REQUEST",
  FETCH_MASTER_SUB_TEAMS_SUCCESS = "FETCH_MASTER_SUB_TEAMS_SUCCESS",
  FETCH_MASTER_SUB_TEAMS_FAILURE = "FETCH_MASTER_SUB_TEAMS_FAILURE",

  FETCH_MASTER_TEAM_DETAILS_REQUEST = "FETCH_MASTER_TEAM_DETAILS_REQUEST",
  FETCH_MASTER_TEAM_DETAILS_SUCCESS = "FETCH_MASTER_TEAM_DETAILS_SUCCESS",
  FETCH_MASTER_TEAM_DETAILS_FAILURE = "FETCH_MASTER_TEAM_DETAILS_FAILURE",

  FETCH_CUSTOMERS_LIST_REQUEST = "FETCH_CUSTOMERS_LIST_REQUEST",
  FETCH_CUSTOMERS_LIST_SUCCESS = "FETCH_CUSTOMERS_LIST_SUCCESS",
  FETCH_CUSTOMERS_LIST_FAILURE = "FETCH_CUSTOMERS_LIST_FAILURE",

  FETCH_TAGS_LIST_REQUEST = "FETCH_TAGS_LIST_REQUEST",
  FETCH_TAGS_LIST_SUCCESS = "FETCH_TAGS_LIST_SUCCESS",
  FETCH_TAGS_LIST_FAILURE = "FETCH_TAGS_LIST_FAILURE",

  FETCH_USER_TYPES_REQUEST = "FETCH_USER_TYPES_REQUEST",
  FETCH_USER_TYPES_SUCCESS = "FETCH_USER_TYPES_SUCCESS",
  FETCH_USER_TYPES_FAILURE = "FETCH_USER_TYPES_FAILURE",

  FETCH_DESIGNATION_LIST_REQUEST = "FETCH_DESIGNATION_LIST_REQUEST",
  FETCH_DESIGNATION_LIST_SUCCESS = "FETCH_DESIGNATION_LIST_SUCCESS",
  FETCH_DESIGNATION_LIST_FAILURE = "FETCH_DESIGNATION_LIST_FAILURE",

  FETCH_SCHEDULED_EMPLOYEES_REQUEST = "FETCH_SCHEDULED_EMPLOYEES_REQUEST",
  FETCH_SCHEDULED_EMPLOYEES_SUCCESS = "FETCH_SCHEDULED_EMPLOYEES_SUCCESS",
  FETCH_SCHEDULED_EMPLOYEES_FAILURE = "FETCH_SCHEDULED_EMPLOYEES_FAILURE",

  FETCH_SCHEDULED_EVENT_EMPLOYEES_REQUEST = "FETCH_SCHEDULED_EVENT_EMPLOYEES_REQUEST",
  FETCH_SCHEDULED_EVENT_EMPLOYEES_SUCCESS = "FETCH_SCHEDULED_EVENT_EMPLOYEES_SUCCESS",
  FETCH_SCHEDULED_EVENT_EMPLOYEES_FAILURE = "FETCH_SCHEDULED_EVENT_EMPLOYEES_FAILURE",
}

export type IEventGroupType = {
  id?: number;
  name?: string;
  status?: string;
  count?: number;
};

export type IHolidaysType = {
  id?: number;
  name?: string;
  date: string;
};

export type IEmployees = {
  employee_id?: string;
  entity_id?: string;
  name?: string;
  employee_code?: string;
  phone_number?: string;
  team?: string;
  designation?: string;
  project_name?: string;
};

export type IGroupMembers = {
  employee_id?: string;
  employee_name?: string;
  phone_number?: string;
  project_name?: string;
};

export type IEventGroupState = {
  groups_data: IEventGroupType[];
  venues_data: IEventGroupType[];
  types_data: IEventGroupType[];
  holidays_data: IHolidaysType[];
  group_members_data: IGroupMembers[];
  employees_with_projects_data: IEmployees[];
};

export type IEventGroupActionCreator = {
  type: string;
  payload: IEventGroupType;
};
